import { useState, useEffect } from "react";

const PageTitle = ({ title, description }) => {
    const [mydate, setmydate] = useState(new Date());
    const weekday = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"];

    useEffect(() => {
        const timer = setInterval(() => {
            setmydate(new Date());
        }, 60000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    let day = weekday[mydate.getDay()];
    const month = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    let months = month[mydate.getMonth()];
    let year = mydate.getFullYear();
    let today = mydate.getDate();
    let hrs = mydate.getHours();
    let min = mydate.getMinutes();

    return (
        <div className="w-full mx-auto">
            <div className="items-center row">
                <div className="col-lg-6 col-md-6">
                    <div className="flex flex-col justify-between px-2 md:px-8">
                        <div className="flex flex-col gap-2">
                            <h1 className="font-[450] text-[22px] text-main-dark max-800:mt-6 translate-y-2.5">
                                {title}
                            </h1>
                            <span className="leading-6 text-base font-normal tracking-wide text-[#101828]">
                                {description}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6 col-md-6">
                    <div className="flex flex-col items-end justify-end pr-4">
                        <span className="text-[#667085] leading-6 font-normal tracking-wide">
                            {hrs}:{min}
                        </span>
                        <span className="text-[#667085] leading-6 font-normal tracking-wide">
                            {day}, <span>{today}</span> <span>{months}</span> {year}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageTitle;
